import { gql } from "@apollo/client";

const JOURNAL_FIELDS = `
  id
  authorId
  type
  dueDate
  status
  state
  assigneeId
  agendaJobId
  domain
  ref {
    id
    collection
  }
  data
  createdAt
  updatedAt
`;

export const UPSERT_JOURNAL = gql`
  mutation UpsertJournal($input: UpsertJournalInput!) {
    upsertJournal(input: $input) {
      isNew
      journal {
        ${JOURNAL_FIELDS}
      }
    }
  }
`;

export const CREATE_JOURNAL = gql`
  mutation CreateJournal($input: CreateJournalInput!) {
    createJournal(input: $input) {
      journal {
        ${JOURNAL_FIELDS}
      }
    }
  }
`;

export const UPDATE_JOURNAL = gql`
  mutation UpdateJournal($input: UpdateJournalInput!) {
    updateJournal(input: $input) {
      journal {
        ${JOURNAL_FIELDS}
      }
    }
  }
`;

export const DELETE_JOURNAL = gql`
  mutation DeleteJournal($id: ID!) {
    deleteJournal(id: $id) {
      id
    }
  }
`;

export const CANCEL_JOURNAL_REMINDER = gql`
  mutation CancelJournalReminder($id: ID!) {
    cancelJournalReminder(id: $id) {
      journal {
        ${JOURNAL_FIELDS}
      }
    }
  }
`;
